import Utils from '../request_util';
import commonstate from '../constant.js';
import commonUtils from "@/js/workspace/common_util.js";
const areacode=[
   
    {name: 'Australia(+61)', id:1,value:61},
    {name: 'Austria(+43)',id:2,value:43},
    {name: 'Belgium(+32)',id:3,value:32},
    {name: 'Brazil(+55)',id:4,value:55},
    {name: 'Canada (+1)',id:5,value:1},
    {name: 'Chile(+56)',id:6,value:56},
    // {name: 'China(+86)', id:7,value:86},
    {name: 'Denmark(+45)',id:8,value:45},
    {name: 'France(+33)',id:9,value:33},
    {name: 'Germany(+49)', id:10,value:49},
    {name: 'Hong Kong(+852)',id:11,value:852},
    {name: 'India(+91)', id:12,value:91},
    {name: 'Indonesia(+62)', id:13,value:62},
    {name: 'Israel(+972)', id:14,value:972},
    {name: 'Italy (+39)', id:15,value:39},
    {name: 'Japan(+81)', id:16,value:81},
    {name: 'Mexico(+52)', id:17,value:52},
    {name: 'Netherlands(+31)', id:18,value:31},
    {name: 'New Zealand(+64)', id:19,value:64},
    {name: 'Norway(+47)', id:20,value:47},
    {name: 'Singapore(+65)', id:21,value:65},
    {name: 'South Africa(+27)', id:22,value:27},
    {name: 'Spain(+34)',id:23,value:34},
    {name: 'Sweden(+46)',id:24,value:46},
    {name: 'Switzerland(+41)',id:25,value:41},
    {name: 'Taiwan(+886)', id:26,value:886},
    {name: 'Thailand(+66)', id:27,value:66},
    {name: 'United Kingdom(+44)', id:28,value:44},
    {name: 'United States(+1)', id:29,value:1},
    {name: 'Vietnam(+84)', id:30,value:84},   
]
export default {
    areacode,
    //根据ip获取用户所在地的区号
    getAreacode(callbak){
        Utils.doDualVerifyRequest("cornet", {userId:commonUtils.getUser().id}).then(res => {
              //console.log(res);
              callbak(res);
        });
    }
}


// WEBPACK FOOTER //
// ./src/js/workspace/area_code_utils.js